import { render, staticRenderFns } from "./ChallengeDetails.vue?vue&type=template&id=638546ec&scoped=true"
import script from "./ChallengeDetails.vue?vue&type=script&lang=ts"
export * from "./ChallengeDetails.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeDetails.vue?vue&type=style&index=0&id=638546ec&prod&lang=scss"
import style1 from "./ChallengeDetails.vue?vue&type=style&index=1&id=638546ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638546ec",
  null
  
)

export default component.exports